// Texts for the about page
const about = {
    schedulesTitle: 'Horarios',

    deliveryTitle: 'Entrega',

    contactTitle: 'Contacto',

    instagramIconTitle: 'Instagram',
    whatsappIconTitle: "What's App",

    schedulesPlaceholder: 'Lunes a viernes de 7 a 12 horas...',
    deliveryPlaceholder: 'Punta del Diablo...',
    instagramPlaceholder: '@instagram',
    whatsAppPlaceholder: '+598 01 234 567',
};

export default about;
